import { Box, Container } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LanaguagesLogo from "../../../common/languagesLogo/lanaguagesLogo";
import apiProjects from "../../../../core/api/projects/api.projects";
import { ModelMedia } from "../../../../models/project";
// import Headings from '../../../common/headings/headings';
import Showcase from "../showcaseDescription/showcase";
import Disclamier from "../../../common/disclamier/disclamier";

export default function ProjectExplore({ location }: { location: any }) {
  const { id } = useParams<{ id: string }>();
  const { state } = location;

  // const [project, setProject] = useState<ModelProject>();
  const [media, setMedia] = useState<ModelMedia>();
  // const dataUrl = "/assets/data/projects.json"
  useEffect(() => {
    const getData = async () => {
      try {
        const value = await apiProjects.getAssetByQuery(id);
        setMedia(value);
      } catch (error) {
        console.error(error);
      }
    };

    getData();
  }, [id]);


  return (
    <div className="ui-position--absolute ui-flex--justify-center app-width-full">
      <Container maxWidth="lg">
        <Box display="flex" flexDirection="column" p={4}>
          <div className="ui-padding--36"></div>
          <h1 className="ui-typo--h1 ui-text--capitalize ui-font-weight--bold">{state?.title}</h1>
          <div className="ui-theme--primary-bg ui-width--264 ui-height--4"></div>
          <div className="ui-padding--24"></div>

          {/* <h2>{state?.description}</h2> */}
          <div className="">
            <h2 className="ui-typo--h6 app-font--secondary app-font-size--half ui-text--capitalize">project description, roles & responsibilities</h2>
            <div className="ui-padding--16"></div>
            <h4 className="ui-typo--h6 ui-font-weight--light">
              {state.txt ? state.txt : "An Exicting project with lots of learning about new technologies and challenging problems, and an excellent team to work with."}
            </h4>
          </div>
          <div className="ui-padding--36"></div>

          {/* <Headings heading="tech stack"></Headings> */}
          <h2 className="ui-typo--h6 app-font--secondary ui-text--capitalize">Tech Stack</h2>
          <div className="ui-border--r10 ui-padding--8 ui-glassmoprhic-bg">
            <LanaguagesLogo languages={state?.languages} expanded={true}></LanaguagesLogo>
          </div>
          <div className="ui-padding--36"></div>
          <h2 className="ui-typo--h6 app-font--secondary ui-text--capitalize">Show Case</h2>
          {media && media.images.length > 0 ? <Showcase media={media?.images} brief={state.txt}></Showcase> : ""}
          <div className="ui-padding--36"></div>
          <Disclamier></Disclamier>
        </Box>
      </Container>
      <div className="ui-padding--36"></div>
    </div>
  );
}
